// extracted by mini-css-extract-plugin
export default {"PaginationRow":"ShipmentTable_PaginationRow__TvEB0"};